import { useLastPathSegment } from 'shared/hooks'
import { useTextEnableLandlineStepsContext } from 'pages/settings/pages/numbers/pages/TextEnableLandline/context/useTextEnableLandlineStepsContext'

export const useProgressInfoTitle = () => {
  const { getProgressInfoTitle } = useTextEnableLandlineStepsContext()

  return getProgressInfoTitle(useLastPathSegment())
}
